import React from 'react';
import * as mui from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Card component for dashboard style layout
export const DashboardCard = ({ title, icon, description, onClick, stats, color = 'primary.main', statsLabel }) => (
  <mui.Paper
    elevation={2}
    sx={{
      p: 3,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      borderLeft: `4px solid ${color}`,
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 6,
        cursor: 'pointer'
      }
    }}
    onClick={onClick}
  >
    <mui.Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
      <mui.Box sx={{ 
        width: 48, 
        height: 48, 
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: `${color}15`,
        color: color
      }}>
        {icon}
      </mui.Box>
      {stats !== undefined && (
        <mui.Box sx={{ textAlign: 'right' }}>
          <mui.Typography variant="h4" color={color} sx={{ fontWeight: 'bold' }}>
            {stats}
          </mui.Typography>
          {statsLabel && (
            <mui.Typography variant="caption" color="text.secondary">
              {statsLabel}
            </mui.Typography>
          )}
        </mui.Box>
      )}
    </mui.Box>
    <mui.Typography variant="h6" gutterBottom>
      {title}
    </mui.Typography>
    <mui.Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
      {description}
    </mui.Typography>
    <mui.Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
      <mui.Typography variant="body2" color={color} sx={{ fontWeight: 'medium', mr: 1 }}>
        Manage
      </mui.Typography>
      <ChevronRightIcon color="action" fontSize="small" />
    </mui.Box>
  </mui.Paper>
);

// Section header component
export const SectionHeader = ({ title, icon, description, action }) => (
  <mui.Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
    <mui.Box>
      <mui.Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {icon && <mui.Box sx={{ mr: 1, color: 'primary.main' }}>{icon}</mui.Box>}
        {title}
      </mui.Typography>
      {description && (
        <mui.Typography variant="body2" color="text.secondary">
          {description}
        </mui.Typography>
      )}
    </mui.Box>
    {action}
  </mui.Box>
);

// Stats overview component
export const StatsOverview = ({ stats = [] }) => (
  <mui.Grid container spacing={2} sx={{ mb: 4 }}>
    {stats.map((stat, index) => (
      <mui.Grid item xs={12} sm={6} md={3} key={index}>
        <mui.Paper elevation={1} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <mui.Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
            {stat.icon && <mui.Box sx={{ mr: 1, color: stat.color || 'primary.main' }}>{stat.icon}</mui.Box>}
            <mui.Typography variant="h5" color={stat.color || 'text.primary'} sx={{ fontWeight: 'medium' }}>
              {stat.value}
            </mui.Typography>
          </mui.Box>
          <mui.Typography variant="body2" color="text.secondary" align="center">
            {stat.label}
          </mui.Typography>
        </mui.Paper>
      </mui.Grid>
    ))}
  </mui.Grid>
);

// Helper function to format dates
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString();
}; 